import React from "react";
import ManageOrder from "../../components/ManageOrder";
import { ORDER_TYPE } from "../../enums/order.enum";

const ManageLabOrder = () => {
  return <ManageOrder orderType={ORDER_TYPE.DIAGNOSTICS} />;
};

export default ManageLabOrder;
